import React from 'react'
import { CardProps } from './types'
import { Season } from '../../reducers/types/reducerTypes'
import FocusableCard from './FocusableCard'
import { useNavigate } from 'react-router'

export function SeasonCard({
  data,
  index,
  onFocus,
  layout,
  ttsCounterText,
  onLeftExit,
  pageDetails,
  focusKey
}: CardProps<Season>) {
  const navigate = useNavigate()

  const seasonImage =
    data.images['season-mezzanine-16x9'] || data.images['asset-mezzanine-16x9']

  const handleOnEnterPress = () => {
    navigate(
      `/seasons/${pageDetails?.slug}/?type=all&season=${data.ordinal}&parent=${pageDetails?.title}`
    )
  }

  return (
    <FocusableCard<Season>
      index={index}
      onFocus={onFocus}
      layout={layout}
      ttsText={`${ttsCounterText} ... Season ${data.ordinal} ... ${data.title}`}
      onLeftExit={onLeftExit}
      onEnterPress={handleOnEnterPress}
      focusKey={focusKey}
    >
      <div className="card">
        {seasonImage && (
          <img
            className="card__background-image"
            src={`${seasonImage}?resize=487x274&format=webp`}
            alt={`${data.title} poster`}
          />
        )}
        <div className="card__overlay" />
      </div>
      <div className="card__caption-container">
        <span className="card__caption">Season {data.ordinal}</span>
      </div>
    </FocusableCard>
  )
}
